import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api'
// import Prettyfier from 'components/UI/Prettyfier';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import Header from 'components/Header/Header';
import Footer from 'components/Footer';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import BlockTitle from 'components/UI/BlockTitle';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';



import {
  fetchData,
  getDataConfidentiality,
  getLoadingError,
} from '../../ducks/asyncFetcher';

const styles = {
  paper: {
    padding: '10px 20px',
    maxWidth: '1024px',
    margin: '0 auto 20px',
    textAlign: 'left'
  }
}
// import Immutable from 'immutable';

const AF_KEY = 'confidentiality';

class Confidentiality extends Component {
  // constructor(props) {
  //   super(props);
  // }
  componentDidMount() {

    this.props.onMount();

  }
  render() {

    const { $$data: $$confidentiality, classes } = this.props;

    // const $$legal = $$data !== undefined ? $$data;

    return (<div className="home">
    <ScrollToTopOnMount/>
    <Header current={false} condensed={true}/>
    <div id="legal" className="Legal">
      <Choose>
        <When condition={$$confidentiality !== undefined}>
          <ScrollToTopOnMount/>
          <div className="legalWrapper">
            <Box align="middle" mt={4} mb={8}>
              <Typography variant="h2" gutterBottom>{$$confidentiality.get('title')}</Typography>
            </Box>
            <Paper classes={{root: classes.paper}}>
              <div className="content"><Paragrapher prettyfy={true} text={$$confidentiality.get('content')} transformBullets={false}/></div>
            </Paper>
          </div>
        </When>
        <Otherwise>
          <div>LOADING !!</div>
        </Otherwise>
      </Choose>
    </div>
    <Footer style={{zIndex: 189, marginTop: -10}}/>
  </div>

);
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataConfidentiality(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.confidentiality}))}
  };
}
// export default Mission;
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Confidentiality));



// WEBPACK FOOTER //
// ./src/components/Confidentiality/Confidentiality.jsx